import {ArrayUtil, P} from "oca-lib-web";
import { getGlobal } from 'reactn';

export default class DataMappingUtil {

    public static async getDataMappings(projectId:string):Promise<Array<DataMapping>> {
        let dataMappings = await getGlobal().dataManager.get("getDataMappings", projectId);
        return P.resolve(dataMappings);
    }

    public static replaceData(dataTerm:string, dataMappings:Array<DataMapping>): string {
        let dataTermLower = dataTerm.toLowerCase();
        let dataMapping = ArrayUtil.getItem(dataMappings, "dataTerm", dataTermLower);
        return dataMapping ? dataMapping.replacement : dataTerm;
    }
}